export const publish = (eventName, data) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(eventName, data);
  }
};

export const getResultAnalytics = (style, subCategory2) => {
  const pageName = `style quiz>results>${style?.toLowerCase()}`;
  return {
    pageName: style ? pageName : 'style quiz>results>default',
    subCategory1: 'style quiz>results',
    subCategory2: subCategory2 || 'style quiz>results>default'
  };
};

export const getStartedAnalytics = () => {
  return {
    pageName: 'style quiz>get started',
    subCategory1: 'style quiz>get started',
    subCategory2: 'style quiz>get started'
  };
};